'use strict';

angular.module('imagetrend.components')
    .directive('hlpFormBuilderQuestionShow', [function () {
        return {
            restrict: 'AE',
            scope: {
                form: '=?',
                question: '=?',
                resultSet: '=?',
                component: '=?',
                parameters: '=?'
            },
            controller: ['$scope', function ($scope) {
                $scope.$watch('form.apply_label_position', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        $scope.question.label_position = $scope.form.label_position;
                    }
                });

                $scope.applicationTypeExists = function (question) {
                    var exists = false;

                    if (question.data_point_code == 'certification_levels') {
                        $scope.component.questions.forEach(function (q) {
                            if (q.question_type.code == 'application_type') {
                                exists = true;
                            }
                        })
                    }

                    return exists;
                }
            }],

            replace: true,
            transclude: true,
            templateUrl: 'templates/form-builder/form-builder-question-show/form-builder-question-show.html',
            link: function (scope, elem, attrs, ctrl) {

            }
        };
    }])
;